<template>

  <section class="top-leagues">

    <div class="section-header">

      <h2>لیگ‌های منتخب</h2>

      <router-link
          to="/competition/3"
          class="view-all-btn"
      >
        همه لیگ ها
      </router-link>

    </div>


    <div
        v-if="leagues.length"
        class="featured-leagues"
    >

      <!-- HERO -->
      <router-link
          v-if="heroLeague"
          :to="`/competition/${heroLeague.id}`"
          class="league-hero"
      >

        <div class="hero-logo">

          <img
              :src="heroLeague.logo"
              :alt="heroLeague.name"
          >

        </div>

        <div class="hero-content">

          <span class="hero-label">
            لیگ منتخب
          </span>

          <h3>
            {{ getLeagueName(heroLeague.shortName) }}
          </h3>

          <span class="hero-english">
            {{ heroLeague.name }}
          </span>

          <span
              v-if="heroLeague.season"
              class="hero-season"
          >
            {{ heroLeague.season }}
          </span>

        </div>



      </router-link>


      <!-- سه لیگ دیگر -->
      <div class="other-leagues">

        <router-link
            v-for="league in otherLeagues"
            :key="league.id"
            :to="`/competition/${league.id}`"
            class="league-card"
        >

          <img
              :src="league.logo"
              :alt="league.name"
          >

          <div class="league-info">

            <span class="league-name">
              {{ getLeagueName(league.shortName) }}
            </span>

            <small>
              {{ league.name }}
            </small>

          </div>
        </router-link>

      </div>

    </div>

  </section>

</template>


<script>

import { leagueNames } from '@/utils/translations'

export default {

  name: 'TopLeagues',

  computed: {

    leagues() {

      // 🇮🇷 لیگ برتر ایران همیشه اول (هیرو)، بعد لیگ‌های معروف
      const IRAN_SLUG = 'iran-pro-league';
      const priorityOrder = [
        'PL',
        'PD',
        'SA',
        'BL1'
      ]

      const rank = (league) => {
        if (league.slug === IRAN_SLUG) return 0;
        const idx = priorityOrder.indexOf(league.shortName);
        return idx === -1 ? priorityOrder.length + 1 : idx + 1;
      }

      const competitions =
          this.$store.getters.competitions || []

      return [...competitions]
          .sort((a, b) =>
              rank(a) - rank(b) || a.name.localeCompare(b.name, 'fa')
          )
          .slice(0, 4)

    },

    heroLeague() {

      return this.leagues[0] || null

    },

    otherLeagues() {

      return this.leagues.slice(1, 4)

    }

  },

  methods: {

    getLeagueName(shortName) {

      return leagueNames[shortName] || shortName

    }

  }

}

</script>


<style scoped lang="scss">

.top-leagues {

  margin-block: 42px;
  padding: 10px 10px 30px;
  background-color: #f3f3f3;
  border-radius: 8px;
}


/* -------------------------
   HEADER
------------------------- */

.section-header {

  display: flex;

  justify-content: space-between;

  align-items: center;

  margin-bottom: 18px;

}

.section-header h2 {

  margin: 0;

  font-size: 1.25rem;

  font-weight: 800;

}


/* -------------------------
   VIEW ALL
------------------------- */

.view-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 9px 16px;

  background: linear-gradient(135deg, #081c15, #14532d);
  color: #fff;

  border: 1px solid rgba(66, 211, 146, 0.25);
  border-radius: 10px;

  font-size: 0.8rem;
  font-weight: 600;

  text-decoration: none;

  box-shadow: 0 4px 12px rgba(8, 28, 21, 0.15);

  transition: transform 0.2s ease,
  box-shadow 0.2s ease,
  background 0.2s ease;
}

.view-all-btn span {
  font-size: 1rem;
  transition: transform 0.2s ease;
}

.view-all-btn:hover {
  background: linear-gradient(135deg, #14532d, #166534);

  transform: translateY(-2px);

  box-shadow: 0 7px 18px rgba(8, 28, 21, 0.22);
}

.view-all-btn:hover span {
  transform: translateX(-4px);
}

.view-all-btn:active {
  transform: translateY(0);
}


/* -------------------------
   MAIN LAYOUT
------------------------- */

.featured-leagues {

  display: grid;

  grid-template-columns: 1.45fr 1fr;

  gap: 14px;

}


/* -------------------------
   HERO
------------------------- */

.league-hero {

  position: relative;

  min-height: 190px;

  padding: 28px;

  border-radius: 20px;

  overflow: hidden;

  display: flex;

  align-items: center;

  gap: 24px;

  text-decoration: none;

  color: #fff;

  background:
      linear-gradient(
              135deg,
              #081c15,
              #0f3d2b
      );

  box-shadow:
      0 8px 24px rgba(0, 0, 0, .12);

  transition: .25s;

}

.league-hero:hover {

  transform: translateY(-3px);

  box-shadow:
      0 12px 30px rgba(0, 0, 0, .17);

}


/* دایره پشت لوگو */

.league-hero::before {

  content: '';

  position: absolute;

  width: 230px;

  height: 230px;

  border-radius: 50%;

  background: rgba(255, 255, 255, .05);

  left: -70px;

  bottom: -100px;

}


/* لوگو */

.hero-logo {

  position: relative;

  z-index: 1;

  width: 110px;

  height: 110px;

  flex-shrink: 0;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: rgba(255, 255, 255, .96);

}

.hero-logo img {

  width: 72px;

  height: 72px;

  object-fit: contain;

}


/* متن Hero */

.hero-content {

  position: relative;

  z-index: 1;

  display: flex;

  flex-direction: column;

  align-items: flex-start;

  gap: 5px;

}

.hero-label {

  color: #86efac;

  font-size: .75rem;

  font-weight: 700;

}

.hero-content h3 {

  margin: 0;

  font-size: 1.35rem;

  font-weight: 900;

}

.hero-english {

  color: rgba(255, 255, 255, .65);

  font-size: .75rem;

  direction: ltr;

}

.hero-season {

  margin-top: 6px;

  padding: 4px 9px;

  border-radius: 7px;

  background: rgba(255, 255, 255, .1);

  font-size: .7rem;

}

.hero-arrow {

  position: absolute;

  left: 24px;

  bottom: 22px;

  font-size: 1.3rem;

  opacity: .7;

}


/* -------------------------
   OTHER LEAGUES
------------------------- */

.other-leagues {

  display: grid;

  grid-template-columns: repeat(3, 1fr);

  gap: 14px;

}


.league-card {

  min-width: 0;

  min-height: 190px;

  padding: 20px 12px;

  border-radius: 18px;

  background: #fff;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  gap: 12px;

  text-decoration: none;

  color: #333;

  box-shadow:
      0 4px 14px rgba(0, 0, 0, .07);

  transition: .25s;

}

.league-card:hover {

  transform: translateY(-3px);

  box-shadow:
      0 8px 20px rgba(0, 0, 0, .11);

}

.league-card img {

  width: 52px;

  height: 52px;

  object-fit: contain;

}

.league-info {

  display: flex;

  flex-direction: column;

  align-items: center;

  text-align: center;

  gap: 4px;

}

.league-name {

  font-size: .9rem;

  font-weight: 800;

  line-height: 1.5;

}

.league-info small {

  color: #999;

  font-size: .65rem;

  direction: ltr;

}

.card-arrow {

  color: #2563eb;

  font-size: .9rem;

  opacity: .7;

}


/* -------------------------
   TABLET
------------------------- */

@media (max-width: 900px) {

  .featured-leagues {

    grid-template-columns: 1fr;

  }

  .league-hero {

    min-height: 150px;

  }

  .other-leagues {

    grid-template-columns: repeat(3, 1fr);

  }

  .league-card {

    min-height: 150px;

  }

}


/* -------------------------
   MOBILE
------------------------- */

@media (max-width: 768px) {

  .top-leagues {

    margin-block: 30px;

  }

  .section-header {

    margin-bottom: 14px;

  }

  .section-header h2 {

    font-size: 1.05rem;

  }

  .view-all-btn {

    padding: 7px 11px;

    font-size: .7rem;

  }


  /* Hero */

  .league-hero {

    min-height: 135px;

    padding: 18px;

    gap: 16px;

    border-radius: 16px;

  }

  .hero-logo {

    width: 78px;

    height: 78px;

  }

  .hero-logo img {

    width: 52px;

    height: 52px;

  }

  .hero-content h3 {

    font-size: 1.05rem;

  }

  .hero-arrow {

    left: 18px;

    bottom: 16px;

  }


  /* سه لیگ */

  .other-leagues {

    display: flex;

    overflow-x: auto;

    gap: 10px;

    padding: 3px 2px 12px;

    scrollbar-width: none;

    -webkit-overflow-scrolling: touch;

  }

  .other-leagues::-webkit-scrollbar {

    display: none;

  }

  .league-card {

    flex: 0 0 112px;

    min-height: 125px;

    padding: 12px 8px;

    border-radius: 15px;

    gap: 8px;

  }

  .league-card img {

    width: 38px;

    height: 38px;

  }

  .league-name {

    font-size: .75rem;

  }

  .league-info small {

    display: none;

  }

  .card-arrow {

    display: none;

  }

}

</style>